const SET_RUNNING_STATE = 'scratch-gui/vm-status/SET_RUNNING_STATE';
const SET_TURBO_STATE = 'scratch-gui/vm-status/SET_TURBO_STATE';
const SET_TARGET_STATE = 'scratch-gui/vm-status/SET_TARGET_STATE';


const initialState = {
    currentVMTargets: '',
    running: false,
    turbo: false,
    initVMTargets: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_RUNNING_STATE:
        return Object.assign({}, state, {
            running: action.running
        });
    case SET_TURBO_STATE:
        return Object.assign({}, state, {
            turbo: action.turbo
        });
    case SET_TARGET_STATE:
        return Object.assign({}, state, {
            initVMTargets: action.initVMTargets
        });
    default:
        return state;
    }
};

const setRunningState = function (running) {
    return {
        type: SET_RUNNING_STATE,
        running: running
    };
};

const setTurboState = function (turbo) {
    return {
        type: SET_TURBO_STATE,
        turbo: turbo
    };
};

const setTargetState = function (initVMTargets){

    return {
        type: SET_TARGET_STATE,
        initVMTargets: initVMTargets
    };
};

export {
    reducer as default,
    initialState as vmStatusInitialState,
    setRunningState,
    setTurboState,
    setTargetState
};
